module.exports = __webpack_public_path__ + "img/skip-forward-fill.d7e9a4db.svg";